// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__4P-Z3","img":"Hero_img__WsvzR","text":"Hero_text__GIUo2","title":"Hero_title__bfVE-","message":"Hero_message__MNXOd"};